<template>
  <van-popup v-model:show="isShow" position="bottom" closeable round safe-area-inset-bottom>
    <div class="box" v-if="isShow">
      <h2 class="title">确认商品</h2>
      <div class="fvlr goods">
        <div class="imgBox">
          <img :src="goodsInfo.img" />
        </div>
        <div class="fhlu">
          <div class="name">{{ goodsInfo.name }}</div>
          <div class="price">厂家建议零售价* ￥{{ goodsInfo.uniformPrice || 0 }}</div>
        </div>
      </div>
      <CurrentDealer from="tyre" />
      <div class="fvlr bugNum">
        <div>购买数量</div>
        <van-stepper v-model="productNum" :min="min" :max="max" button-size="22" />
      </div>
      <van-button class="btn" @click="clickSureBtn" :disabled="isChecking" type="primary" block>{{ isChecking ? '信息校验中...' : '确 定' }}</van-button>
    </div>
  </van-popup>
</template>

<script>
import { reactive, toRefs, watch, onMounted, nextTick } from 'vue'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import { useStore } from 'vuex'
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import { addShoppingCar, updateShoppingInf } from '@/api/shoppingCar'
import { showToast } from '@/util/couponCollection'
import { getDefaultCommoditie } from '@/api/tyre'
import { getDistance } from '@/util'
export default {
  components: {
    CurrentDealer
  },
  emits: ['updateShoppingSuccess'],
  props: ['datas', 'showTyreNum', 'from', 'type'],
  setup(props, { emit }) {
    const store = useStore()
    const router = useRouter()
    let { datas, showTyreNum, from, type } = toRefs(props)
    let { currentGoodsInfo, dealerInfo } = store.state
    const state = reactive({
      isShow: false,
      datas,
      showTyreNum,
      goodsInfo: currentGoodsInfo,
      dealerInfo,
      productNum: 1,
      isChecking: false,
      max: 4,
      min: 1,
      noNtockMsg: '该经销商无对应库存',
      from,
      type
    })
    onBeforeRouteLeave(() => {
      state.isShow = false
    })
    const getDealerCommoditieFn = async () => {
      // console.log("getDealerCommoditieFn--statr");
      let { lat, lng } = store.state.position
      let { currentGoodsInfo, dealerInfo, shoppingCartDealerObj } = store.state
      let gsCode = dealerInfo.gs_code
      let tyreId = currentGoodsInfo.id
      let label = `${gsCode}_${tyreId}_tyre`
      if (shoppingCartDealerObj[label]) {
        store.commit('SETDEARINFO', shoppingCartDealerObj[label])
        // console.log("getDealerCommoditieFn--has", shoppingCartDealerObj[label]);
        return
      }
      let params = { tyreId, gsCode, latitude: lat, longitude: lng }
      let { list = [] } = await getDefaultCommoditie(params)
      let data = list[0] ? list[0] : {}
      // console.log("getDealerCommoditieFn--req", data);
      let dealer = data?.dealer
      if (!dealer) return
      dealer.allStock = data.stock + data.dealer_stock
      dealer.stock = data.stock
      dealer.next_day_stock = data.next_day_stock
      dealer.dealer_stock = data.dealer_stock
      dealer.two_hours_stock = data.two_hours_stock
      dealer.distance = getDistance(dealer.distance)
      setTimeout(() => {
        store.commit('SETDEARINFO', dealer)
        store.commit('SETSHOPPINGCARTDEALEROBJ', {
          ...shoppingCartDealerObj,
          [label]: dealer
        })
      }, 0)
    }
    watch(
      () => state.showTyreNum,
      async () => {
        let { currentGoodsInfo, dealerInfo, stepperOption } = store.state // 更新数据
        state.goodsInfo = currentGoodsInfo
        state.dealerInfo = dealerInfo
        state.productNum = (state.datas && state.datas.num) || 1
        let stockAmount = state.datas?._data?.stockAmount
        if (state.from === 'tyreDetail') {
          state.productNum = stepperOption.value
          stockAmount = stepperOption.max
        }
        let max = Math.min.apply(Math, [stockAmount, 4])
        state.max = max
        nextTick(async () => {
          state.isShow = true
          if (state.from === 'shoppingCar') {
            await getDealerCommoditieFn()
          }
        })
      }
    )
    watch(
      () => store.state.dealerInfo,
      n => {
        if (state.isShow && state.from === 'shoppingCar') {
          state.dealerInfo = n
          const twoStock = Number(n.dealer_stock + n.two_hours_stock)
          const nextStock = Number(n.dealer_stock + n.stock)
          const maxStock = Math.max.apply(Math, [twoStock, nextStock])
          let max = Math.min.apply(Math, [maxStock, 4])
          state.max = isNaN(max) ? 0 : max
        }
      }
    )
    watch(
      () => state.productNum,
      n => {
        if (state.min === 0) {
          state.isShow && showToast(state.noNtockMsg)
          return
        }
        store.commit('SETSTEPPEROPTION', {
          ...store.state.stepperOption,
          value: n
        })
        if (n >= state.max) {
          state.isShow && showToast(`商品加购件数已达到最大购买量${n}件`)
        }
      }
    )
    watch(
      () => store.state.stepperOption,
      n => {
        if (state.isShow && state.from === 'tyreDetail') {
          state.max = Math.min.apply(Math, [n.max ? n.max : 0, 4])
        }
      }
    )
    const maxWatchHandle = max => {
      if (max < 1) {
        state.isShow && showToast(state.noNtockMsg)
        state.min = 0
      } else {
        state.min = 1
      }
    }
    watch(
      () => state.max,
      n => {
        nextTick(async () => {
          maxWatchHandle(n)
        })
      },
      { immediate: true }
    )
    // 点击确认按钮
    const clickSureBtn = async () => {
      if (state.from === 'shoppingCar') {
        // 购物车更新
        await updateShoppingCarFn()
      }

      if (state.from === 'tyreDetail') {
        if (state.type === 'addShoppingCar') {
          // 加入购物车
          await tyreAddShoppingCar()
        }
        if (state.type === 'bugNow') {
          // showToast("跳转到轮胎结算页面");
          // 立即购买
          state.datas.count = state.productNum
          store.dispatch('setCurrentBuyProductInfo', [state.datas])
          router.push({
            path: '/createOrder',
            query: {
              from: 'commodityDetails',
              gs_code: store.state.dealerInfo.gs_code,
              event: '轮胎下单'
            }
          })
        }
      }
    }
    // 更新购物车
    const updateShoppingCarFn = async () => {
      let { dealerInfo } = store.state
      if (!dealerInfo.gs_code) {
        showToast('请选择经销商')
        return
      }
      if (state.productNum < 1) {
        showToast('请修改商品数量')
        return
      }
      // 购物车修改参数
      let { productType, loyaltyId, shoppingCarDetailId } = store.state.currentGoodsInfo
      let params = {
        // customerCarId: currentCarInfo.id, //车辆编号
        delStatusFlag: 0, //删除状态
        gsCode: dealerInfo.gs_code, //经销商code
        productId: loyaltyId, //商品编号
        productQuantity: state.productNum, //购买商品数量
        productType: productType, //购买商品类型{1:计划2:轮胎}
        id: shoppingCarDetailId //购物车明细编号
      }
      console.log(params)
      try {
        await updateShoppingInf(params)
        emit('updateShoppingSuccess')
        state.isShow = false
      } catch (e) {
        showToast(e.message, '购物车信息更新失败')
      }
    }
    /// 轮胎加入购物车
    const tyreAddShoppingCar = async () => {
      let { dealerInfo } = store.state
      if (!dealerInfo.gs_code) {
        showToast('请选择经销商')
        return
      }
      let params = {
        customerCarId: -1, //车辆编号
        delStatusFlag: 0, //删除状态
        gsCode: dealerInfo.gs_code, //经销商code
        productId: state.goodsInfo.loyaltyId, //商品编号
        productQuantity: state.productNum, //购买商品数量
        productType: 2 //购买商品类型{1:计划2:轮胎}
      }
      try {
        const { productId } = await addShoppingCar(params)
        console.log(productId)
        if (productId) {
          showToast('加入购物车成功')
          state.isShow = false
        }
        store.dispatch('getCountOfShoppingCar')
      } catch (e) {
        showToast(e.message, '加入购物车失败')
      }
    }

    onMounted(async () => {})
    return {
      ...toRefs(state),
      updateShoppingCarFn,
      clickSureBtn
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 15px 20px 50px;
  text-align: left;
  .van-cell {
    padding: 13px 0;
    border-style: solid;
    border-color: rgba(204, 204, 204, 0.5);
    border-width: 0.5px 0;
  }
  :deep(.van-field__label) {
    color: #333;
    font-weight: bold;
    margin-right: 0;
  }
  :deep(.van-field__control:disabled) {
    color: #333;
  }
}
.title {
  padding: 5px 20px 20px;
  text-align: center;
  color: #333;
  font-weight: bold;
  font-size: 15px;
}
.van-field__label {
  width: 6em;
}
.goods {
  height: 72px;
  font-size: 14px;
  color: #333333;
  padding-bottom: 20px;
  border-bottom: solid 1px #cccccc;
  margin-bottom: 16px;
}
.price {
  font-size: 14px;
  font-weight: 600;
  color: #3088c5;
  margin-top: 8px;
}
.imgBox {
  width: 96px;
  height: 72px;
  margin: 0 11px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.fhlu {
  width: 100%;
  height: 100%;
}
.bugNum {
  padding: 13px 0;
  overflow: auto;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);
}
.btn {
  margin-top: 25px;
}
</style>
